import { render, staticRenderFns } from "./FacebookInboxPage.vue?vue&type=template&id=35c2eec8&"
import script from "./FacebookInboxPage.vue?vue&type=script&lang=js&"
export * from "./FacebookInboxPage.vue?vue&type=script&lang=js&"
import style0 from "./FacebookInboxPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports